class scanModalCtrl {
    constructor($rootScope, $scope, $timeout, $uibModalInstance, httpRequest) {
        $scope.title = '开始扫描'
        $scope.resultText = '正在扫描中，请勿有其他操作'
        $scope.result = false
        $scope.getInputBatchInfo = function getInputBatchInfo(batchNo) {
            httpRequest.get_getInputBatchInfo({
                batchNo: batchNo || '',
            }).then((res) => {
                if (res.data.value) {
                    if (res.data.value.batchStatus != 2) {
                        $scope.title = `正在扫描。已成功扫描${res.data.value.sucessCount ? res.data.value.sucessCount : 0}张发票，${(res.data.value.receiveCount ? res.data.value.receiveCount : 0) - (res.data.value.sucessCount ? res.data.value.sucessCount : 0)}张失败`
                        $rootScope.scanTimeout = $timeout(() => {
                            $scope.getInputBatchInfo(res.data.value.batchNo)
                        }, 5000)
                    } else {
                        $scope.resultText = '扫描完成'
                        $scope.title = `本次共成功扫描${res.data.value.sucessCount ? res.data.value.sucessCount : 0}张发票，${(res.data.value.receiveCount ? res.data.value.receiveCount : 0) - (res.data.value.sucessCount ? res.data.value.sucessCount : 0)}张失败`
                    }
                    if (res.data.value.remark) { $scope.result = res.data.value.remark.split(';') } else $scope.result = false
                } else {
                    // $scope.title = '正在扫描'
                    // $scope.resultText = '正在扫描中，请勿有其他操作'
                    $rootScope.scanTimeout = $timeout(() => {
                        $scope.getInputBatchInfo()
                    }, 5000)
                }
            })
        }
        $scope.getInputBatchInfo()
        $scope.ok = function ok() {
            $uibModalInstance.close()
        }
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss()
        }
    }
}

scanModalCtrl.$inject = ['$rootScope', '$scope', '$timeout', '$uibModalInstance', 'httpRequest']
export default scanModalCtrl



// WEBPACK FOOTER //
// ./src/app/input/inputInvoice/collection/scanModalCtrl.js